module.exports = __webpack_public_path__ + "static/toolkit-package-json-4841e006eac28be3bc3c8234c9ec3ed8.png";